import { createAction, props } from '@ngrx/store';
import {
  IEvent,
  IEventCreate,
  IEventHistoryCounts,
  IEventHistoryEntry,
  IEventUpdate,
} from '@app/api/interfaces/event.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IEventsRequestState } from '@app/main/main-screen/store/data/events/events.state';

export const loadEvents = createAction(
  '[Events] Load Events',
  props<{ triggerId: string; request: IEventsRequestState }>()
);

export const loadEventsSuccess = createAction(
  '[Events] Load Events Success',
  props<{ triggerId: string; request: IEventsRequestState; events: IEvent[] }>()
);

export const eventsFailure = createAction('[Events] Load Failure', props<{ error: IApiBaseErrorResponse }>());

export const createEvent = createAction(
  '[Events] Create Event',
  props<{ requestId: string; projectId: string; data: IEventCreate }>()
);

export const createEventSuccess = createAction(
  '[Events] Create Event Success',
  props<{ requestId: string; event: IEvent; historyCounts: IEventHistoryCounts }>()
);

export const createEventFailure = createAction(
  '[Events] Create Event Failure',
  props<{ requestId: string; error: IApiBaseErrorResponse }>()
);

export const updateEvent = createAction(
  '[Events] Update Event',
  props<{ requestId: string; projectId: string; eventId: string; data: IEventUpdate }>()
);

export const updateEventSuccess = createAction(
  '[Events] Update Event Success',
  props<{ requestId: string; event: IEvent; historyCounts: IEventHistoryCounts }>()
);

export const updateEventFailure = createAction(
  '[Events] Update Event Failure',
  props<{ requestId: string; error: IApiBaseErrorResponse }>()
);

export const deleteEvent = createAction(
  '[Events] Delete Event',
  props<{ requestId: string; projectId: string; eventId: string }>()
);

export const deleteEventSuccess = createAction(
  '[Events] Delete Event Success',
  props<{ requestId: string; eventId: string }>()
);

export const deleteEventFailure = createAction(
  '[Events] Delete Event Failure',
  props<{ requestId: string; error: IApiBaseErrorResponse }>()
);

export const loadEventHistory = createAction(
  '[Events] Load Event History',
  props<{ projectId: string; eventId: string }>()
);

export const loadEventHistorySuccess = createAction(
  '[Events] Load Event History Success',
  props<{ eventId: string; entries: IEventHistoryEntry[] }>()
);

export const loadEventHistoryFailure = createAction(
  '[Events] Load Event History Failure',
  props<{ eventId: string; error: IApiBaseErrorResponse }>()
);
